import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import css from './styles.css'

const cx = classnames.bind(css)

class BlockStyleButton extends Component {
  static propTypes = {
    style: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    icon: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
  }

  onToggle = (e) => {
    e.preventDefault()
    this.props.onToggle(this.props.style)
  }

  render() {
    const { isActive, icon, label } = this.props

    const cssClass = cx('styleButtonWrapper', { active: isActive })
    let iconColor = isActive ? '#5890ff' : null

    const Icon = icon

    return (
      <span className={cssClass} onMouseDown={this.onToggle}>
        {
          icon ?
            <Icon color={iconColor} /> :
            label
        }
      </span>
    )
  }
}

export default BlockStyleButton



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/StyleControls/BlockStyleButton.js